import Image from 'next/image';
import React from 'react'

const PrevButton = ({ handlePrev, isPrevDisabled }) => {
  return (
    <button
      onClick={handlePrev}
      disabled={isPrevDisabled}
      className="absolute left-4 bottom-2.5 bg-black bg-opacity-40 flex items-center disabled:opacity-50 justify-center w-8 h-8 rounded-full backdrop-invert-custom"
    >
      <Image src="/icons/prev.svg" width={12} height={12} alt="left-arrow" />
    </button>
  );
}

export default PrevButton